import { ApiFilestackImageData } from 'api/types/ApiFilestackImageData';
import { ImagePickerField } from 'components/Form/ImagePickerField';

type Props = {
  altText?: string;
  centerButton?: boolean;
  description?: string;
  extraAnalyticsData?: Record<string, unknown>;
  inlineLabel?: boolean;
  label?: string;
  message?: string;
  name: string;
  noMargin?: boolean;
  onChange?: (newImage: ApiFilestackImageData | null) => void;
  confirmModal?: boolean;
  overlayButton?: boolean;
  recommendedDimensions?: {
    height: number;
    width: number;
  };
  size?: number;
};

export function LogoPickerField({
  altText,
  centerButton,
  confirmModal,
  description,
  extraAnalyticsData,
  inlineLabel,
  label,
  message,
  name,
  noMargin,
  onChange,
  overlayButton,
  recommendedDimensions,
  size,
}: Props) {
  return (
    <ImagePickerField
      altText={altText}
      previewWidth={size || 128}
      previewHeight={size || 128}
      format="logo"
      message={message || getText('Drag a logo here')}
      name={name}
      inlineLabel={inlineLabel}
      label={label}
      description={description}
      centerButton={centerButton}
      overlayButton={overlayButton}
      confirmModal={confirmModal}
      onChange={onChange}
      noMargin={noMargin}
      extraAnalyticsData={extraAnalyticsData}
      recommendedDimensions={recommendedDimensions}
    />
  );
}
